import type { PortableTextBlock } from '@portabletext/react';
import SimpleRichText from '../richTextComponents/SimpleRichText';
import { simpleRichTextGroq } from '../richTextComponents/simpleRichTextGroq';
import type { ImageWithMetadata} from './SanityImage';
import { CaptionedSanityImage, imageWithMetadataGroq } from './SanityImage';
import * as style from './WineStyle.module.css';

export const wineStyleGroq = /* groq */ `
{
    _id,
    _type,
    'slug': slug.current,
    title,
    'type': select(
        wine == 'redwine' => 'rødvin',
        wine == 'whitewine' => 'hvitvin',
        'unknown'
    ),
    summary,
    image ${imageWithMetadataGroq},
    description[] ${simpleRichTextGroq},
    page,
    hybrisReference
}
`;

export interface WineStyleProps {
    _id: string;
    _type: 'wineStyle';
    slug?: string;
    title?: string;
    type: 'rødvin' | 'hvitvin';
    summary?: string;
    image?: ImageWithMetadata;
    description: PortableTextBlock[];
    page?: {
        path: string;
    };
    hybrisReference: string;
}

export function WineStyle({ wineStyle }: { wineStyle: WineStyleProps }) {
    return (
        <div className={style.wineStyle} id={wineStyle.slug}>
            <CaptionedSanityImage
                image={wineStyle.image}
                widths={[358, 358 * 2, 358 * 3, 688]}
                sizes="(min-width: 872px) 688px, calc(100vw - 64px)"
            />
            <h2>
                <a href={`${wineStyle.page?.path}#${wineStyle.slug}`}>{wineStyle.title}</a>
            </h2>
            <SimpleRichText value={wineStyle.description} />
        </div>
    );
}
